<template>
  <div class="diagnoseteacher">
    <p v-html="data"></p>
  </div>
</template>

<script>
export default {
  name: "diagnoseteacher",
  data() {
    return {
      data:
        "<html>\n" +
        "\n" +
        "<head>\n" +
        '<meta http-equiv=Content-Type content="text/html; charset=gb2312">\n' +
        '<meta name=Generator content="Microsoft Word 12 (filtered)">\n' +
        "<style>\n" +
        "<!--\n" +
        " /* Font Definitions */\n" +
        " @font-face\n" +
        "\t{font-family:宋体;\n" +
        "\tpanose-1:2 1 6 0 3 1 1 1 1 1;}\n" +
        "@font-face\n" +
        '\t{font-family:"Cambria Math";\n' +
        "\tpanose-1:2 4 5 3 5 4 6 3 2 4;}\n" +
        "@font-face\n" +
        "\t{font-family:Calibri;\n" +
        "\tpanose-1:2 15 5 2 2 2 4 3 2 4;}\n" +
        "@font-face\n" +
        "\t{font-family:Tahoma;\n" +
        "\tpanose-1:2 11 6 4 3 5 4 4 2 4;}\n" +
        "@font-face\n" +
        '\t{font-family:"\\@宋体";\n' +
        "\tpanose-1:2 1 6 0 3 1 1 1 1 1;}\n" +
        " /* Style Definitions */\n" +
        " p.MsoNormal, li.MsoNormal, div.MsoNormal\n" +
        "\t{margin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\ttext-align:justify;\n" +
        "\ttext-justify:inter-ideograph;\n" +
        "\tfont-size:10.5pt;\n" +
        '\tfont-family:"Calibri","sans-serif";}\n' +
        "h1\n" +
        '\t{mso-style-link:"标题 1 Char";\n' +
        "\tmargin-right:0cm;\n" +
        "\tmargin-left:0cm;\n" +
        "\tfont-size:24.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "h2\n" +
        '\t{mso-style-link:"标题 2 Char";\n' +
        "\tmargin-right:0cm;\n" +
        "\tmargin-left:0cm;\n" +
        "\tfont-size:18.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "h3\n" +
        '\t{mso-style-link:"标题 3 Char";\n' +
        "\tmargin-right:0cm;\n" +
        "\tmargin-left:0cm;\n" +
        "\tfont-size:13.5pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "h4\n" +
        '\t{mso-style-link:"标题 4 Char";\n' +
        "\tmargin-right:0cm;\n" +
        "\tmargin-left:0cm;\n" +
        "\tfont-size:12.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "h5\n" +
        '\t{mso-style-link:"标题 5 Char";\n' +
        "\tmargin-right:0cm;\n" +
        "\tmargin-left:0cm;\n" +
        "\tfont-size:10.0pt;\n" +
        "\tfont-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "p.MsoHeader, li.MsoHeader, div.MsoHeader\n" +
        '\t{mso-style-link:"页眉 Char";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\ttext-align:center;\n" +
        "\tlayout-grid-mode:char;\n" +
        "\tborder:none;\n" +
        "\tpadding:0cm;\n" +
        "\tfont-size:9.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";}\n' +
        "p.MsoFooter, li.MsoFooter, div.MsoFooter\n" +
        '\t{mso-style-link:"页脚 Char";\n' +
        "\tmargin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\tlayout-grid-mode:char;\n" +
        "\tfont-size:9.0pt;\n" +
        '\tfont-family:"Calibri","sans-serif";}\n' +
        "p\n" +
        "\t{margin-right:0cm;\n" +
        "\tmargin-left:0cm;\n" +
        "\tfont-size:12.0pt;\n" +
        "\tfont-family:宋体;}\n" +
        "p.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph\n" +
        "\t{margin:0cm;\n" +
        "\tmargin-bottom:.0001pt;\n" +
        "\ttext-align:justify;\n" +
        "\ttext-justify:inter-ideograph;\n" +
        "\ttext-indent:21.0pt;\n" +
        "\tfont-size:10.5pt;\n" +
        '\tfont-family:"Calibri","sans-serif";}\n' +
        "span.1Char\n" +
        '\t{mso-style-name:"标题 1 Char";\n' +
        '\tmso-style-link:"标题 1";\n' +
        "\tfont-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "span.2Char\n" +
        '\t{mso-style-name:"标题 2 Char";\n' +
        '\tmso-style-link:"标题 2";\n' +
        "\tfont-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "span.3Char\n" +
        '\t{mso-style-name:"标题 3 Char";\n' +
        '\tmso-style-link:"标题 3";\n' +
        "\tfont-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "span.4Char\n" +
        '\t{mso-style-name:"标题 4 Char";\n' +
        '\tmso-style-link:"标题 4";\n' +
        "\tfont-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "span.5Char\n" +
        '\t{mso-style-name:"标题 5 Char";\n' +
        '\tmso-style-link:"标题 5";\n' +
        "\tfont-family:宋体;\n" +
        "\tfont-weight:bold;}\n" +
        "span.Char\n" +
        '\t{mso-style-name:"页眉 Char";\n' +
        "\tmso-style-link:页眉;}\n" +
        "span.Char0\n" +
        '\t{mso-style-name:"页脚 Char";\n' +
        "\tmso-style-link:页脚;}\n" +
        " /* Page Definitions */\n" +
        " @page Section1\n" +
        "\t{size:595.3pt 841.9pt;\n" +
        "\tmargin:72.0pt 90.0pt 72.0pt 90.0pt;\n" +
        "\tlayout-grid:15.6pt;}\n" +
        "div.Section1\n" +
        "\t{page:Section1;}\n" +
        " /* List Definitions */\n" +
        " ol\n" +
        "\t{margin-bottom:0cm;}\n" +
        "ul\n" +
        "\t{margin-bottom:0cm;}\n" +
        "-->\n" +
        "</style>\n" +
        "\n" +
        "</head>\n" +
        "\n" +
        "<body lang=ZH-CN style='text-justify-trim:punctuation'>\n" +
        "\n" +
        "<div class=Section1 style='layout-grid:15.6pt'>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span\n" +
        "style='font-family:宋体;color:#333333'>亲爱的用户，您好：</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        '宋体;color:#333333\'>园丁快诊教师端是由北京<a name="_GoBack"></a>云圈科技有限公司（下称云圈）基于教育信息资源开发的应用产品。云圈非常重视您的个人信息或个人数据信息。在您仔细阅读、了解并同意本政策之前，不要向云圈提交任何个人信息、数据等隐私信息（下称</span><span\n' +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>“</span><span\n' +
        "style='font-family:宋体;color:#333333'>信息</span><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>”</span><span\n' +
        "style='font-family:宋体;color:#333333'>）。如果您是未成年人，应当与父母或监护人共同审阅本协议，以确保您及您的父母或监护人了解本协议。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span\n" +
        "style='font-family:宋体;color:#333333'>通过本隐私政策，云圈希望您了解以下内容：</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.</span><span\n' +
        "style='font-family:宋体;color:#333333'>云圈如何收集及使用您的信息</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>2.</span><span\n' +
        "style='font-family:宋体;color:#333333'>云圈如何披露您的信息</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>3.</span><span\n' +
        "style='font-family:宋体;color:#333333'>如何更新、变更或检查您的信息</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>4.</span><span\n' +
        "style='font-family:宋体;color:#333333'>云圈如何保护您的信息</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>5.</span><span\n' +
        "style='font-family:宋体;color:#333333'>云圈如何处理未成年人提供的信息</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>6.</span><span\n' +
        "style='font-family:宋体;color:#333333'>第三方服务提供商</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>7.</span><span\n' +
        "style='font-family:宋体;color:#333333'>信息传输</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>8.</span><span\n' +
        "style='font-family:宋体;color:#333333'>本政策的更新</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>9.</span><span\n' +
        "style='font-family:宋体;color:#333333'>与云圈联络</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>请注意，本政策是云圈针对信息处理和保护的主要策略，但本政策可能无法解决您的信息处理和保护的所有问题，因此云圈会针对某些特定服务提供特定隐私政策作为本政策的补充，以便在基于特定目的处理和保护您的信息时通知客户，请您在使用云圈产品或服务时，注意其他形式的此类通知。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><b><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>云圈如何收集及使用您的信息</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.1&nbsp;</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>云圈收集及使用信息的方式、时机与目的</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.1.1</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>个人注册信息</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>当您注册云圈账号时，我们会根据您的选择收集您的手机号，以及微信、</span><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>QQ</span><span\n' +
        "style='font-family:宋体;color:#333333'>、微博等第三方登录平台的登录授权信息，以帮助完成账号相关权益的保存以及跨平台共享。您还可以根据自身需求上传头像、昵称等信息，主要为您提供更多个性化的产品服务。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>请您妥善保管您的账号、密码，如您将密码告知他人、与他人共享注册账户或其他个人保管不善事由导致的任何个人信息泄露、丢失、被盗用或被篡改等，云圈不对此承担责任。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.1.2</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>获取设备权限</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.1.2.1</span><span\n' +
        "style='font-family:宋体;color:#333333'>网络权限：主要用于播放音视频及列表页面访问。当在使用手机流量播放音视频时，需获得您的确认后才会使用。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.1.2.2</span><span\n' +
        "style='font-family:宋体;color:#333333'>相机权限：主要用于根据个人需要的个性化头像上传。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.1.2.3</span><span\n' +
        "style='font-family:宋体;color:#333333'>语音权限：用于应用中的语音互动功能的使用。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.1.2.4</span><span\n' +
        "style='font-family:宋体;color:#333333'>位置权限：用于提供基于位置的互动服务的使用。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.1.3</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>收集设备信息</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>云圈可能会收集某些信息进行统计与分析，这类信息包括您的设备名称、设备版本、设备识别号码</span><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>&nbsp;(IMEI</span><span\n' +
        "style='font-family:宋体;color:#333333'>、</span><span lang=EN-US style='font-family:\n" +
        '"Tahoma","sans-serif";color:#333333\'>ESN</span><span style=\'font-family:宋体;\n' +
        'color:#333333\'>、</span><span lang=EN-US style=\'font-family:"Tahoma","sans-serif";\n' +
        "color:#333333'>MEID</span><span style='font-family:宋体;color:#333333'>、</span><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>SN)</span><span\n' +
        "style='font-family:宋体;color:#333333'>、设备的粗略地理位置信息</span><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'> (</span><span\n' +
        "style='font-family:宋体;color:#333333'>例如设备所在的网络位置编码</span><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>)</span><span\n' +
        "style='font-family:宋体;color:#333333'>、运营商网络</span><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>ID(PLMN)</span><span\n' +
        "style='font-family:宋体;color:#333333'>、应用使用情况、您访问互联网的</span><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>IP</span><span\n' +
        "style='font-family:宋体;color:#333333'>地址、设备存储。云圈收集并处理这类信息的唯一目的是：提供您最佳的人性化用户体验、提供个性化内容、改善我们的产品、分析我们的运营效率、统计市场占有率、改善网络和服务的安全性，以及启用您的售后保障服务。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.1.4</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>收集播放记录信息</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>云圈可能会收集您的视频播放记录，使您能够查看您的浏览历史。我们还会收集您在订阅、收藏功能中添加的信息，使您能够更加轻松快捷地访问您感兴趣的内容。您的观看历史、订阅、收藏信息会存储在我们的服务器中，以便您通过多终端登录时使用上述功能，您也可以随时在任意客户端删除这些信息。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>1.2&nbsp;</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>去标识化信息的收集及使用</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>「去标识化信息」是指无法识别特定个人身份的信息，例如我们应用的启动次数、页面的点击次数。云圈会收集这类信息，以了解用户如何使用我们的应用、产品或服务，如此云圈才能进行改善，以满足客户的需求。云圈可以自行决定是否基于任何其他目的，收集、使用、移转或披露非个人信息。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><b><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>2.</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>云圈如何披露您的信息</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>只有符合下列情况时，云圈才会披露您的信息。在下列情形之外，云圈绝不会将您的信息披露给第三方</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>(1)</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>您已明确同意：在得到您的批准后，云圈才会将您的信息透露给其他公司；</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>(2)</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>将您的信息披露给云圈关联公司或授权合作的第三方：</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>云圈可能需要通过某些合作方为您提供某些服务，因此云圈需要将您的部分信息共享给合作方，以便丰富我们的服务以及满足您的需求，例如，当您决定在线购买云圈产品时，云圈将需要将您的信息上传到云圈后台，方便您跨平台享有购买的权益；</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><b><span lang=EN-US\n" +
        'style=\'font-family:"Tahoma","sans-serif";color:#333333\'>(3)</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>依法律要求，披露您的信息：</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>依法律、法院等司法机关命令或其他法律程序的规定，或相关政府机关的要求，云圈可能会提供您的信息。在云圈涉及重组、合并或清算的情况下，您的信息可能也会提供给交易方。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><b><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>3.</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>如何更新、变更或检查您的信息</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>您应该对所提交的信息的准确性负责，云圈将尽到商业上合理的努力，确保您信息的准确性。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><b><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>4.</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>云圈如何保护您的信息</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>云圈采取合理的预防措施，包括但不限于物理上、技术及制度等方面，以保护您的信息不会遭受未经授权的浏览、披露、滥用、变更、破坏以及损失。例如，在技术方面，云圈使用防病毒软件、加密保护、监控我们的系统，以及增强我们数据中心的攻击防护；物理方面，云圈设定门禁措施及访问控制，仅允许需要这类信息的业务人员浏览；在制度方面，则通过对云圈员工进行安全与隐私保护知识培训，确保员工了解保护数据的重要性。虽然我们采用合理的措施来保护您的个人数据，但没有任何安全措施能够百分之百完美或牢不可破。但由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而导致您的信息泄露、丢失、被盗用或被篡改的，云圈无需承担责任，但应采取补救措施，按照规定及时告知您并向有关主管部门报告。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><b><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>5.</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>云圈如何处理未成年人的信息</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>云圈鼓励父母或监护人指导未成年人使用云圈的产品或服务。如果法律有相关规定，云圈不会在未征得监护人同意的前提下收集未成年人的信息。我们只会在法律允许的范围内，或依当地法律取得监护人的同意，或是为保护未成年人而使用或披露有关未成年人的信息。「未成年人」的定义应考虑适用的法律，以及各国家和地区的文化惯例。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>若您是未成年人的监护人，请您关注您监护的未成年人是否是在取得您的授权同意之后使用使用云圈的产品或服务。如果您对您所监护的未成年人的个人信息有疑问，请通过第</span><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>10</span><span\n' +
        "style='font-family:宋体;color:#333333'>条中的联系方式与我们联系。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><b><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>6.</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>第三方服务提供商</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>为方便您的访问并丰富您的体验，可能会有非云圈的第三方提供内容或因特网链接。您可以选择是否访问这类链接或内容，是否使用这类第三方的服务或产品，但云圈对于这些并没有控制权。云圈无法控制第三方的任何隐私权和数据保护措施，这类措施不受本政策管理，本政策也不适用于您自行选择提供给第三方的任何信息，<u>请您在使用这类第三方的服务或产品时查看第三方的隐私保护政策</u>。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><b><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>7.</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>信息传输</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>云圈产品与服务可能会由位于世界不同国家或地区的资源与服务器提供。因此，您的信息可能会跨国界而传输到您使用我们服务所在国家或地区之外的国家和地区，那些国家或地区可能没有对信息提供具体保护的法律，或是实行不同的数据保护法。在这类情况下，云圈将采取措施，确保有法律基础可进行这类传输，以及依适用法律，会对您信息提供适当的保护，例如，通过使用相关授权单位核准的标准合约（必要时），以及通过使用其他适当的技术与信息安全措施。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><b><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>8.</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>本隐私政策的更新</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>云圈可能会不定期修订本《隐私政策》的条款，云圈将在修订生效前通过云圈儿歌的显著位置提示，或尽可能通过可行的渠道和方法，将修订通知您，请您更新最新版本的云圈产品查询修订后的《隐私政策》。</span><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>&nbsp;</span><span\n' +
        "style='font-family:宋体;color:#333333'>在该种情况下，<u>若您继续使用云圈的产品或服务，即表示同意受修订后的《隐私政策》的约束</u>。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><b><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>9.</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>其他</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>本隐私政策是云圈统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于云圈用户。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='margin-left:18.0pt;text-align:left'><b><span\n" +
        'lang=EN-US style=\'font-family:"Tahoma","sans-serif";color:#333333\'>10.</span></b><b><span\n' +
        "style='font-family:宋体;color:#333333'>与云圈联络</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>如果您有任何问题、意见或建议，以及要求删除后台的用户数据，您可以与我们联络。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>公司注册地址：北京市海淀区海淀大街</span><span lang=EN-US style='font-family:\n" +
        '"Tahoma","sans-serif";color:#333333\'>27</span><span style=\'font-family:宋体;\n' +
        'color:#333333\'>号三层</span><span lang=EN-US style=\'font-family:"Tahoma","sans-serif";\n' +
        "color:#333333'>3-072</span><span style='font-family:宋体;color:#333333'>。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>公司常用办公地址：北京市海淀区花园东路</span><span lang=EN-US style='font-family:\n" +
        '"Tahoma","sans-serif";color:#333333\'>35</span><span style=\'font-family:宋体;\n' +
        "color:#333333'>号。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        '宋体;color:#333333\'>公司联系方式：</span><span lang=EN-US style=\'font-family:"Tahoma","sans-serif";\n' +
        "color:#333333'>fumeiling@yunquancn.com/+86-15011154548</span><span\n" +
        "style='font-family:宋体;color:#333333'>。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=left style='text-align:left'><span style='font-family:\n" +
        "宋体;color:#333333'>云圈保留本政策条款之解释权。</span></p>\n" +
        "\n" +
        "<p class=MsoNormal align=right style='text-align:right'><b><span\n" +
        "style='font-family:宋体;color:#333333'>北京云圈科技有限公司</span></b></p>\n" +
        "\n" +
        "<p class=MsoNormal><span lang=EN-US>&nbsp;</span></p>\n" +
        "\n" +
        "</div>\n" +
        "\n" +
        "</body>\n" +
        "\n" +
        "</html>\n"
    };
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped>
h1,
h2 {
  font-weight: bold;
  size: 26px;
}
ol {
  float: left;
  margin-left: 20px;
  padding: 10px;
}
li {
  flex: 1;
  margin-top: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}

a {
  color: #42b983;
}
p {
  color: #000;
  size: 26px;
  text-align: left;
  width: 100%;
  letter-spacing: 4px;
  line-height: 200%;
}
.hello {
  width: 100%;
}
img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/DiagnosePrivacyPolicyTeacher.vue